import PaymentInformations from './PaymentInformations.jsx';
import RefundInformations from './RefundInformations.jsx';
import React from 'react';

const CustomerPaymentRefund = ({
  getMiddleBoolean,
  getMiddleText,
  paymentDayOptions,
  paymentFrequencyOptions,
  selectedTab,
  paymentDayIsVisible
}) => {
  if (selectedTab !== 0) {
    return null;
  }

  return (
    <>
      {(getMiddleBoolean('PAIEMENTETREMBOURSEMENT_TYPE_PAIEMENT_PRELEVEMENT_AUTORISE') ||
        getMiddleBoolean('PAIEMENTETREMBOURSEMENT_TYPE_PAIEMENT_VIREMENT_AUTORISE')) && (
        <PaymentInformations
          paymentDayIsVisible={
            getMiddleBoolean('PAIEMENTETREMBOURSEMENT_JOUR_PRELEVEMENT_EST_NECESSAIRE') &&
            paymentDayIsVisible
          }
          paymentFrequencyIsVisible={getMiddleBoolean(
            'PAIEMENTETREMBOURSEMENT_FREQUENCE_PAIEMENT_PRELEVEMENT_EST_NECESSAIRE'
          )}
          getMiddleText={getMiddleText}
          getMiddleBoolean={getMiddleBoolean}
          paymentDayOptions={paymentDayOptions}
          paymentFrequencyOptions={paymentFrequencyOptions}
        />
      )}

      {getMiddleBoolean('PAIEMENTETREMBOURSEMENT_REMBOURSEMENT_EST_NECESSAIRE') && (
        <RefundInformations getMiddleText={getMiddleText} getMiddleBoolean={getMiddleBoolean} />
      )}
    </>
  );
};

export default CustomerPaymentRefund;
